import loglevel from 'loglevel';
import { captureException as sentryCaptureException } from '@sentry/react';

import { env } from 'constants/index';

if (process.env.NODE_ENV === env.DEVELOPMENT) {
    loglevel.enableAll();
} else {
    loglevel.disableAll();
}

export const { warn, info, trace, debug } = loglevel;

export const error = err => {
    loglevel.error(err);

    sentryCaptureException(err);
};
